import { createSelector } from 'reselect';

export function sidebarSelector(state) {
  return state.sidebar || {};
}

export function getOpenedIds() {
  return createSelector(sidebarSelector, (sidebar) => sidebar.openedIds);
}
